import React from 'react';
import "./news.css"
import Video from "../videos/video3.mp4"
import { useTranslation } from 'react-i18next'; // Add this import

const News16 = () => {
    const { t } = useTranslation(); // Add this hook

    return (
        <div>
            <br />
            <br />
            <br />
            <div class="news">
                <article class="news-item">
                    <div class="news-item__date">
                        <svg class="news-item__date-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#718096" stroke-width="2">
                            <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
                            <line x1="16" y1="2" x2="16" y2="6" />
                            <line x1="8" y1="2" x2="8" y2="6" />
                            <line x1="3" y1="10" x2="21" y2="10" />
                        </svg>
                        03.04.2025
                    </div>

                    <h2 class="news-item__title">
                        {t('news16.title')}
                    </h2>

                    <div class="news-item__content">
                        <div class="video-player">
                            <video height="500px" controls>
                                <source src={Video} type="video/mp4" />
                                Ваш браузер не поддерживает видео элемент.
                            </video>
                        </div>
                    </div>


                </article>
            </div>
        </div>
    );
}

export default News16;